import script from "./CustomNodeLCA.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomNodeLCA.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__